export const StatsTransactionDates = [
  {value: null, label: 'On the date each transaction was completed'},
  {value: 'lead', label: 'On the date the lead was acquired (all time)'},
  {value: 'lead7days', label: 'On the date the lead was acquired (+ 7 days)'},
  {value: 'lead14days', label: 'On the date the lead was acquired (+ 14 days)'},
  {value: 'lead21days', label: 'On the date the lead was acquired (+ 21 days)'},
  {value: 'lead28days', label: 'On the date the lead was acquired (+ 28 days)'},
];
